import angular from 'angular';
import uiRouter from 'angular-ui-router';
import eventComponent from './event.component';

let eventModule = angular.module('event', [
  uiRouter
])
  .config(($stateProvider) => {
    'ngInject';
    $stateProvider
      .state('events.event', {
        url: '/:officeId/:eventId',
        component: 'event',
        resolve: {
          selectedEvent: (EventsService, $stateParams) => EventsService.details($stateParams.officeId, $stateParams.eventId),
          $title: (selectedEvent) => `Eventi - ${selectedEvent.title}`
        }
      })
  })
  .component('event', eventComponent)
  .name;

export default eventModule;



// WEBPACK FOOTER //
// ./client/app/components/events/event/event.js